const events = require("./auditLoadEvents.js");

const Survey = require("~/types/Survey.js");

const alterEgoLoadHandlers = {
    [events.Loading.Name](prev, event) {
        const update = {
            CurrentSurvey: Survey.FromLoadingEvent(prev.CurrentSurvey)
        };

        const result = Object.assign({}, prev, update);

        return result;
    },
    [events.Loaded.Name](prev, event) {
        const update = {
            CurrentSurvey: Survey.FromLoadedEvent(prev.CurrentSurvey, event.Data)
        };

        const result = Object.assign({}, prev, update);

        return result;
    },
    [events.LoadedSummary.Name](prev, event) {
        const update = {
            CurrentSurvey: Survey.FromLoadedSummaryEvent(prev.CurrentSurvey, event.Data)
        };
        
        const result = Object.assign({}, prev, update);

        return result;
    },
    [events.LoadedLegacySurvey.Name](prev, event) {
        const update = {
            CurrentSurvey: Survey.FromLoadedLegacySurveyEvent(prev.CurrentSurvey, event.Data)
        };

        const result = Object.assign({}, prev, update);

        return result;
    },
    [events.LoadErrored.Name](prev, event) {        
        const update = {
            CurrentSurvey: Survey.FromErrorEvent(prev.CurrentSurvey, event.Error)
        };
        
        const result = Object.assign({}, prev, update);

        return result;
    }
};

module.exports = alterEgoLoadHandlers;


// WEBPACK FOOTER //
// ./src/events/auditLoad/auditLoadHandlers.js